module.exports = __webpack_public_path__ + "img/javascript.19c84fba.svg";